import Gallery from 'react-grid-gallery'
import PropTypes from 'prop-types'
import React from 'react'
import shuffleArray from 'shuffle-array'

class PhotosRoomPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            images: this.props.images
        }
    }

    render() {
        return (
            <div className='photoGalleries'>
                <h2>Photo Gallery - リビングルーム</h2>
                <ul className="breadcrumb">
                    <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
                        <a href="/" itemProp="url">
                            <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
                        </a>
                    </li>
                    <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
                        <span itemProp="title"> <i className="fas fa-caret-right"></i> <i className="fas fa-images"></i> Photo Gallery - リビングルーム</span>
                    </li>
                </ul>
                <div style={{
                    display: "block",
                    minHeight: "1px",
                    width: "100%",
                    border: "1px solid #ddd",
                    overflow: "auto",
                    textAlign: "center",
                    background: "white"
                }}>
                    <Gallery
                        images={this.state.images}
                        enableImageSelection={false}
                    />
                </div>
            </div>
        )
    }
}

PhotosRoomPage.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            thumbnail: PropTypes.string.isRequired,
            srcset: PropTypes.array,
            caption: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            thumbnailWidth: PropTypes.number.isRequired,
            thumbnailHeight: PropTypes.number.isRequired,
            isSelected: PropTypes.bool
        })
    ).isRequired
}

PhotosRoomPage.defaultProps = {
    images: shuffleArray([
        {
            src: "https://sharehome.biz/images/living06.jpg",
            thumbnail: "https://sharehome.biz/images/living06.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "18畳のスペースにカウンターキッチン",
            thumbnailCaption: "18畳のスペースにカウンターキッチン"
        },
        {
            src: "https://sharehome.biz/images/living02.jpg",
            thumbnail: "https://sharehome.biz/images/living02.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "正面：ぬれ縁付きの中庭が広がる、左：駄菓子屋",
            thumbnailCaption: "正面：ぬれ縁付きの中庭が広がる、左：駄菓子屋"
        },
        {
            src: "https://sharehome.biz/images/dresser01.jpg",
            thumbnail: "https://sharehome.biz/images/dresser01.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "ドレッサーの鏡を下ろすと、作業机になります",
            thumbnailCaption: "ドレッサーの鏡を下ろすと、作業机になります"
        },
        {
            src: "https://sharehome.biz/images/washing_machine01.jpg",
            thumbnail: "https://sharehome.biz/images/washing_machine01.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "洗濯機は大容量10kg",
            thumbnailCaption: "洗濯機は大容量10kg"
        },
        {
            src: "https://sharehome.biz/images/wash_basin01.jpg",
            thumbnail: "https://sharehome.biz/images/wash_basin01.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "洗面台が各階にあります",
            thumbnailCaption: "洗面台が各階にあります"
        },
        {
            src: "https://sharehome.biz/images/storage_space01.jpg",
            thumbnail: "https://sharehome.biz/images/storage_space01.jpg",
            thumbnailWidth: 320,
            thumbnailHeight: 240,
            caption: "床下収納",
            thumbnailCaption: "床下収納"
        },
        {
            src: "https://sharehome.biz/images/bath_room01.jpg",
            thumbnail: "https://sharehome.biz/images/bath_room01.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "浴槽はゆったりサイズの1.6m",
            thumbnailCaption: "浴槽はゆったりサイズの1.6m"
        },
        {
            src: "https://sharehome.biz/images/shower01.jpg",
            thumbnail: "https://sharehome.biz/images/shower01.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "浴室の他にシャワールームがあります",
            thumbnailCaption: "浴室の他にシャワールームがあります"
        },
        {
            src: "https://sharehome.biz/images/storage_space02.jpg",
            thumbnail: "https://sharehome.biz/images/storage_space02.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "階段下のデッドスペースを利用した収納",
            thumbnailCaption: "階段下のデッドスペースを利用した収納"
        },
        {
            src: "https://sharehome.biz/images/kitchen01.jpg",
            thumbnail: "https://sharehome.biz/images/kitchen01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "IHコンロとオーブン",
            thumbnailCaption: "IHコンロとオーブン"
        },
        {
            src: "https://sharehome.biz/images/kitchen02.jpg",
            thumbnail: "https://sharehome.biz/images/kitchen02.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "食洗機",
            thumbnailCaption: "食洗機"
        },
        {
            src: "https://sharehome.biz/images/kitchen03.jpg",
            thumbnail: "https://sharehome.biz/images/kitchen03.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "キッチンの流台",
            thumbnailCaption: "キッチンの流台"
        },
        {
            src: "https://sharehome.biz/images/shoe_box01.jpg",
            thumbnail: "https://sharehome.biz/images/shoe_box01.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "シュークローク",
            thumbnailCaption: "シュークローク"
        },
        {
            src: "https://sharehome.biz/images/storage_space03.jpg",
            thumbnail: "https://sharehome.biz/images/storage_space03.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "各個室に1畳分のクローゼット",
            thumbnailCaption: "各個室に1畳分のクローゼット"
        },
        {
            src: "https://sharehome.biz/images/key_device01.jpg",
            thumbnail: "https://sharehome.biz/images/key_device01.jpg",
            thumbnailWidth: 200,
            thumbnailHeight: 150,
            caption: "鍵付きの個室",
            thumbnailCaption: "鍵付きの個室"
        },
        {
            src: "https://sharehome.biz/images/bed01.jpg",
            thumbnail: "https://sharehome.biz/images/bed01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "ベッドとマットレスが標準装備",
            thumbnailCaption: "ベッドとマットレスが標準装備"
        },
        {
            src: "https://sharehome.biz/images/television01.jpg",
            thumbnail: "https://sharehome.biz/images/television01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "43型のテレビ",
            thumbnailCaption: "43型のテレビ"
        },
        {
            src: "https://sharehome.biz/images/microwave_oven01.jpg",
            thumbnail: "https://sharehome.biz/images/microwave_oven01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "Panasonic社製の高機能電子レンジ",
            thumbnailCaption: "Panasonic社製の高機能電子レンジ"
        },
        {
            src: "https://sharehome.biz/images/toaster01.jpg",
            thumbnail: "https://sharehome.biz/images/toaster01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "大人気のAladdinのオーブントースター",
            thumbnailCaption: "大人気のAladdinのオーブントースター"
        },
        {
            src: "https://sharehome.biz/images/refrigerator01.jpg",
            thumbnail: "https://sharehome.biz/images/refrigerator01.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "大容量冷蔵庫",
            thumbnailCaption: "大容量冷蔵庫"
        },
        {
            src: "https://sharehome.biz/images/rice_cooker01.jpg",
            thumbnail: "https://sharehome.biz/images/rice_cooker01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "定番のTiger炊飯器",
            thumbnailCaption: "定番のTiger炊飯器"
        },
        {
            src: "https://sharehome.biz/images/kitchen04.jpg",
            thumbnail: "https://sharehome.biz/images/kitchen04.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "Franfranのカップボード",
            thumbnailCaption: "Franfranのカップボード"
        },
        {
            src: "https://sharehome.biz/images/kitchen05.jpg",
            thumbnail: "https://sharehome.biz/images/kitchen05.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "おしゃれな電子ケトル",
            thumbnailCaption: "おしゃれな電子ケトル"
        },
        {
            src: "https://sharehome.biz/images/living05.jpg",
            thumbnail: "https://sharehome.biz/images/living05.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "カウチソファーでゆっくりできます",
            thumbnailCaption: "カウチソファーでゆっくりできます"
        },
        {
            src: "https://sharehome.biz/images/living07.jpg",
            thumbnail: "https://sharehome.biz/images/living07.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "日差しが差し込む開放感のあるリビング",
            thumbnailCaption: "日差しが差し込む開放感のあるリビング"
        },
        {
            src: "https://sharehome.biz/images/room01.jpg",
            thumbnail: "https://sharehome.biz/images/room01.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "シャンデリアと花柄のカーテンが綺麗です",
            thumbnailCaption: "シャンデリアと花柄のカーテンが綺麗です"
        },
        {
            src: "https://sharehome.biz/images/room02.jpg",
            thumbnail: "https://sharehome.biz/images/room02.jpg",
            thumbnailWidth: 400,
            thumbnailHeight: 300,
            caption: "全個室にエアコン、テレビ、光回線、1畳分の収納、ベランダが用意されています",
            thumbnailCaption: "全個室にエアコン、テレビ、光回線、1畳分の収納、ベランダが用意されています"
        },
        {
            src: "https://sharehome.biz/images/room03.jpg",
            thumbnail: "https://sharehome.biz/images/room03.jpg",
            thumbnailWidth: 300,
            thumbnailHeight: 400,
            caption: "カーテン越しに心地よい光が降り注ぎます",
            thumbnailCaption: "カーテン越しに心地よい光が降り注ぎます"
        }
    ])
}

export default PhotosRoomPage


// WEBPACK FOOTER //
// ./src/PhotosRoomPage.js